import React from "react";
import { View } from "react-native";

export const VerticalSpacer = React.memo((props: { height: number }) => <View style={{ height: props.height }} />);
export const HorizontalSpacer = React.memo((props: { width: number }) => <View style={{ width: props.width }} />);
